<template>
    <div class="table_wrap">
        <today-banner-list-component :todayBannerType="'todayBanner'" :todayBannerData="exposureData"></today-banner-list-component>
        <div class="sub_title pt10 pb10">노출중인 배너목록</div>
        <div class="table_wrap">
            <el-table
                :data="exposureData"
                style="width: 100%"
                empty-text="데이터가 없습니다."
            >
                <el-table-column
                    class="table_no"
                    type="index"
                    label="#"
                    width="70"
                    class-name="num"
                    :index="tableIndex"
                >
                </el-table-column>

                <el-table-column
                    align="center"
                    width=""
                    :prop="'b_title'"
                    label="제목"
                    class-name="table_bottons"
                >
                </el-table-column>

                <el-table-column
                    align="center"
                    width=""
                    label="노출기간"
                    class-name="table_bottons"
                >
                    <template slot-scope="scope">
                        <div>
                            {{scope.row.b_period_first}} ~ {{scope.row.b_period_end}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    align="center"
                    width="200"
                    label="옵션"
                    class-name="table_bottons"
                >
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            type="warning"
                            @click="$router.push(`todayBanner/${scope.row.b_idx}`)">
                            상세
                        </el-button>
                        <el-button
                            size="mini"
                            type="danger" @click="deleteExposureBanner(scope.row)">
                            삭제
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import TodayBannerListComponent from "@/components/todayBanner/TodayBannerListComponent";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/mixins/event-bus";

export default {
    name: 'TodayListComponent',
    mixins: [alertMixins],
    components: {TodayBannerListComponent},
    inject: [],
    provide() {
        return {
            setExposureBanner: this.setExposureBanner,
            deleteExposureBanner: this.deleteExposureBanner,
        }
    },
    props: {},
    data() {
        return {
            exposureData: [],
            exposures: [],
        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {
        this.getExposureBanner();
        EventBus.$on('getExposureBanner', this.getExposureBanner);
    },
    beforeDestroy() {
        EventBus.$off('getExposureBanner');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getExposureBanner() {
            let params = {
                ip: 0,
                dis: 1,
            }
            this.exposureData = [];
            try {
                this.$api.$todayBanner.getTodayBanner(params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.exposureData = res.List;
                    }
                })
            } catch(e) {
                console.log(e);
            }
        },

        tableIndex(index) {
            return this.exposureData.length - index;
        },

        setExposureBanner(row = {}) {
            if(util.isEmpty(row)) {
                this.errorAlert('노출에 실패하였습니다.')
                return false;
            }
            let params = {
                b_idx: row.b_idx,
                b_display: 1,
            }
            try {
                this.$api.$todayBanner.updateTodayBanner(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.Type === 1) {
                        this.getExposureBanner();
                        EventBus.$emit('getTodayBanner');
                    }else if(res.Info.Type === -1) {
                        this.errorAlert('노출에 실패하였습니다.')
                    }else if (res.Info.Type === -120) {
                        this.errorAlert('해당 배너는 노출시간이 아닙니다.')
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },

        deleteExposureBanner(row) {
            if(util.isEmpty(row)) {
                this.errorAlert('미노출에 실패하였습니다.')
                return false;
            }
            let params = {
                b_idx: row.b_idx,
                b_display: 0,
            }
            try {
                this.$api.$todayBanner.updateTodayBanner(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.Type === 1) {
                        this.getExposureBanner();
                        EventBus.$emit('getTodayBanner');
                    }else if(res.Info.Type === -1) {
                        this.errorAlert('미노출에 실패하였습니다.')
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>

